<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
        {{'POLICY_VIOLATION' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="contentPadding">
    <div class="dialog-content-container">
        <!-- Left section with error icon -->
        <div class="icon-section">
            <mat-icon class="error-icon">cancel</mat-icon>
        </div>
        
        <!-- Right section with content -->
        <div class="content-section">
            <p class="dialog-paragraph">
                {{ 'POLICY_VIOLATION_PARAGRAPH_1' | translate }}
            </p>
            
            <p class="dialog-paragraph">
                <span>{{ 'CLICK' | translate }} </span>
                <span class="custom-anchor">{{ 'HERE' | translate }}</span>
                <span> {{ 'POLICY_VIOLATION_PARAGRAPH_2' | translate }}</span>
            </p>
            
            <ul class="policy-violation-list">
                <li>{{ 'POLICY_VIOLATION_BULLET_1' | translate }}</li>
                <li>{{ 'POLICY_VIOLATION_BULLET_2' | translate }}</li>
                <li>{{ 'POLICY_VIOLATION_BULLET_3' | translate }}</li>
            </ul>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="actionsPadding">
    <button class="openCloseBtn" mat-raised-button color="primary" (click)="openSapSubmittalRequestDialog()">{{'YES' | translate}}</button>
    <button class="openCloseBtn" mat-raised-button color="primary" mat-dialog-close>{{'NO' | translate}}</button>
    <button class="openCloseBtn" mat-raised-button color="warn" mat-dialog-close>{{'CLOSE' | translate}}</button>
</mat-dialog-actions>